<template>
    <div class="container bg-light position-fixed top-50 start-50 translate-middle w-50 border border-danger p-3"
        style="border-radius: 10px">
        <div class="p-1">
            <button class="btn-close float-end mt-1" @click.prevent="close">
            </button>
            <h3 class="mt-3"> <strong> Editar variable general</strong></h3>
            <p for="editPriceValue">Nuevo valor para la variable <strong> {{ variableInfo.name }} : </strong></p>
            <input type="number" class="form-control mb-3 w-75 mx-auto" min="0" v-model="editVariableValue"
                id="editPriceValue">
            <button class="btn btn-danger my-2" @click.prevent="saveChanges()">Actualizar variable</button>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        getVariableIdToEdit: Number,
    },
    data() {
        return {
            editVariableValue: 0,
            variableInfo: [],
        }
    },
    watch: {
        getVariableIdToEdit(newVal) {
            if (newVal !== null) {
                this.getVariableInfo();
            }
        },
    },
    methods: {
        close() {
            this.variableInfo = [];
            this.$emit("hideEditVariable", false);
        },
        getVariableInfo() {
            try {
                axios.get(RUTA_SERVIDOR + "api/variable/get", {
                    params: {
                        variable_id: this.getVariableIdToEdit,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                })
                    //.then((res)=> console.log(res.data[0]))
                    .then((res) => (this.variableInfo = res.data[0]))
                    .catch((err) => console.log(`There has been an error ${err}`));
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
        async saveChanges() {
            if (this.variableInfo.id === 0 || this.variableInfo.id == null) {
                alert("Id de la variable no válido.")
            } else {
                let formData = new FormData();
                formData.append("variable_id", this.variableInfo.id);
                //formData.append("name", this.editVariableName);
                formData.append("value", this.editVariableValue);
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/variable/update",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    //console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        alert("Variable: " + this.variableInfo.name + ", actualizada con exito!");
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
                this.$emit("hideEditVariable", false);
                this.variableInfo = [];
                location.reload();
            }
        },
    }
}
</script>